// extracted by mini-css-extract-plugin
export var AuctionSectionallContainer = "AuctionSection-module--AuctionSectionallContainer--h36hg";
export var AuctionSectionauctionSection = "AuctionSection-module--AuctionSectionauctionSection--SbcNV";
export var AuctionSectioncardsContainer = "AuctionSection-module--AuctionSectioncardsContainer--3amKA";
export var auctionSectionHeader = "AuctionSection-module--auctionSectionHeader--cwuC8";